import React, {useEffect, useState} from 'react';
import {
    Button,
    CardText,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import {Controller, useForm} from "react-hook-form";
import toast from "react-hot-toast";
import {checkIsValid} from "../../../../../utility/helpers";
import axios from "axios";

const EditArea = ({isOpen, handleClose, item}) => {

    const [loading, setLoading] = useState(false);
    const defaultValues = {
        areaId: '',
        areaName: '',
    };

    const {
        control,
        formState,
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors }
    } = useForm({ defaultValues });

    useEffect(() => {
        if (item) {
            setValue('areaId', item.areaId);
            setValue('areaName', item.areaName);
        } else {
            reset();
        }
    }, [item])


    const onSubmit = async (data) => {
        if (checkIsValid(data)) {
            try {
                setLoading(true);
                const resList =  await axios.get(`${process.env.REACT_APP_API_URL}/areas`);
                const areaList = resList.data.data.map(a => {
                    return {
                        areaId: a.id,
                        areaName: a.name
                    }
                });
                if (areaList.find(item => item.areaName === data.areaName)) {
                    setError('areaName', {
                        type: 'custom',
                        message:
                            `El nombre "${data.areaName}" ya se encuentra registrado`
                    })
                    setLoading(false);
                    return;
                }
                const res = await axios.put(`${process.env.REACT_APP_API_URL}/areas/${data.areaId}`, {
                    id: data.areaId,
                    name: data.areaName
                });
                if (res.data.header.code) {
                    toast.success('Area actualizada con exito!');
                    setTimeout(() => window.location.reload(), 1000);
                } else {
                    setLoading(false);
                    toast.error(res.data.header.message);
                    reset();
                }
            } catch (e) {
                console.log(e)
                setLoading(false);
                toast.error(`Ha ocurrido un error: ${e.response.data.title || e.message}`);
                reset();
            }
        } else {

            for (const key in data) {
                if (data[key] === null) {
                    setError(key, {
                        type: 'manual'
                    })
                }
                if (data[key] !== null && data[key].length === 0) {
                    setError(key, {
                        type: 'manual'
                    })
                }
            }
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Editar area</h1>
                    <p>Editar area con los datos correspondientes.</p>
                </div>

                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Actualizando area...</CardText>
                    </div>
                </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='areaId'>
                            Id Area*
                        </Label>
                        <Controller
                          control={control}
                          name='areaId'
                          render={({ field }) => {
                              return (
                                <Input
                                  {...field}
                                    readOnly={true}
                                  disabled={true}
                                  id='areaId'
                                  placeholder=''
                                  value={field.value}
                                  invalid={errors.areaId && true}
                                />
                              )
                          }}
                        />
                        {errors.areaId && <FormFeedback>Por favor ingrese un id valido</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='areaName'>
                            Nombre de Area*
                        </Label>
                        <Controller
                          control={control}
                          name='areaName'
                          render={({ field }) => {
                              return (
                                <Input
                                  {...field}
                                  id='areaName'
                                  placeholder='Area xyz'
                                  value={field.value}
                                  invalid={errors.areaName && true}
                                />
                              )
                          }}
                        />

                        {errors.areaName && (<FormFeedback>{errors.areaName.message ? (
                            <strong>{errors.areaName.message} </strong>
                        ) : (
                            'Por favor ingrese un nombre de area valido'
                        )}</FormFeedback>)}
                    </Col>

                    <Col md={12} xs={12}>
                        <small className={'text-secondary'}>
                            Campos obligatorios (*)
                        </small>
                    </Col>

                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='submit' className='me-1' color='primary' disabled={formState.isSubmitted && !formState.isValid}>
                            Guardar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleClose(false)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}

            </ModalBody>
        </Modal>
    );
};

export default EditArea;
